<template>
  <el-row class="container_self">
    <h3>App列表</h3>
    <el-row class="table_parent">
      <el-row class="search_parent">
        <!-- <el-row>搜索</el-row> -->
        <el-input
          v-model="keyword"
          placeholder="请输入搜索内容"
          clearable
          size="mini"
        ></el-input>
        <el-button type="warning" icon="el-icon-search" @click="searchList" size="mini"
          >搜索</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="mini"
          @click="createApp"
          v-if="permissions.indexOf(2) != -1"
          style="float: right"
          >新增App</el-button
        >
      </el-row>
      <el-table
        :data="tableData"
        v-loading="loading"
        element-loading-background="rgba(0, 0, 0, 0.5)"
        style="width: 100%"
      >
        <el-table-column
          align="center"
          prop="customerName"
          label="所属客户"
          fixed
          width="200"
        ></el-table-column>
        <el-table-column
          prop="appName"
          label="app名称"
          align="center"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="packageName"
          align="center"
          label="App包名"
          width="200"
        ></el-table-column>
        <el-table-column label="WebViewApi开关" align="center" width="150">
          <template slot-scope="scope">
            {{ scope.row.webviewApiEnabled ? "已开启" : "未开启" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="adManagerAppId"
          label="AdManagerAppId"
          align="center"
          width="200"
        ></el-table-column>
        <el-table-column label="url切换时长" align="center" width="100">
          <template slot-scope="scope"> {{ scope.row.urlSwitchTime / 1000 }}秒 </template>
        </el-table-column>
        <el-table-column label="是否可用" align="center" width="80">
          <template slot-scope="scope">
            {{ scope.row.enabled ? "可用" : "不可用" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          align="center"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="updateTime"
          label="更新时间"
          align="center"
          width="200"
        ></el-table-column>
        <el-table-column label="操作" align="center" width="300" fixed="right">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              @click="update(scope.row.packageName)"
              v-if="permissions.indexOf(3) != -1"
              >更新</el-button
            >
            <el-button
              size="mini"
              type="primary"
              @click="check(scope.row.packageName)"
              v-if="permissions.indexOf(5) != -1"
              >查看</el-button
            >
            <el-button
              size="mini"
              type="success"
              @click="checkAu(scope.row)"
              v-if="permissions.indexOf(5) != -1"
              >活跃度查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-row>

    <el-dialog
      :title="title"
      v-loading="loading"
      element-loading-text="加载中，请稍后"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <el-form
        :model="form"
        label-width="140px"
        :rules="rules"
        ref="ruleForm"
        size="mini"
        class="demo-ruleForm search_parent"
      >
        <el-form-item label="客户名称" prop="customerId" v-if="!updatIng && !checkIng">
          <el-select
            v-model="form.customerId"
            remote
            reserve-keyword
            filterable
            placeholder="请输入关键词"
            :remote-method="searchCustom"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户名称" prop="customerId" v-else>
          <el-input v-model="form.customerName" autocomplete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="appName" prop="appName">
          <el-input v-model="form.appName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="app包名" prop="packageName">
          <el-input v-model="form.packageName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
          v-for="(item, index) in form.webviewUrl"
          :key="index + '_url'"
          :label="'webviewUrl ' + (index + 1)"
          class="can_addInput"
        >
          <el-input
            v-model="item.value"
            autocomplete="off"
            @input="change($event)"
          ></el-input
          ><el-button
            type="primary"
            round
            icon="el-icon-plus"
            @click="addItem(form.webviewUrl, item)"
            v-if="item.showAdd"
          ></el-button
          ><el-button
            type="primary"
            round
            icon="el-icon-minus"
            @click="removeItem(form.webviewUrl, item)"
            v-if="item.showMin"
          ></el-button>
        </el-form-item>
        <el-form-item label="webviewApi开关">
          <el-switch
            style="margin-left: 20px"
            v-model="form.webviewApiEnabled"
            active-text="打开"
            inactive-text="关闭"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="是否可用">
          <el-switch
            style="margin-left: 20px"
            v-model="form.enabled"
            active-text="可用"
            inactive-text="禁用"
          >
          </el-switch>
        </el-form-item>

        <el-form-item label="landingLink">
          <el-input
            v-model="form.landingLink"
            placeholder="请输入landingLink"
            style="width: 90%"
          ></el-input>

          <el-button type="success" size="mini" @click="showLinkModal">选择</el-button>
        </el-form-item>

        <el-form-item label="url切换时间（秒）" prop="urlSwitchTime">
          <el-input v-model="form.urlSwitchTime" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="adManagerAppId">
          <el-input v-model="form.adManagerAppId" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm('ruleForm')" size="mini">取 消</el-button>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
          v-if="!checkIng && !updatIng"
          size="mini"
          >确 定</el-button
        >
        <el-button type="primary" @click="offCheck" v-if="checkIng" size="mini"
          >确 定</el-button
        >
        <el-button type="primary" @click="offUpdating" v-if="updatIng" size="mini"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      v-loading="loading"
      element-loading-text="加载中，请稍后"
      :visible.sync="showAu"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="auTitle"
    >
      <el-row class="table_parent">
        <h3>日活</h3>
        <el-date-picker
          v-model="auDate"
          type="date"
          size="mini"
          placeholder="选择日期"
          format="yyyy 年 MM 月 dd 日"
          @change="dAuChange"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <el-table
          :data="dAu"
          style="margin-top: 20px"
          v-loading="dLoading"
          element-loading-background="rgba(0, 0, 0, 0.5)"
        >
          <el-table-column prop="total" label="日活跃量" align="center"></el-table-column>
          <el-table-column label="时间" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.date }}</span>
            </template>
          </el-table-column>
        </el-table>

        <h3 style="margin-top: 30px">周活</h3>
        <el-date-picker
          v-model="auDate"
          type="date"
          size="mini"
          placeholder="选择日期"
          @change="wAuChange"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <el-table
          :data="wAu"
          style="margin-top: 20px"
          v-loading="wLoading"
          element-loading-background="rgba(0, 0, 0, 0.5)"
        >
          <el-table-column prop="total" label="周活跃量" align="center"></el-table-column>
          <el-table-column label="时间" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.weekStartDate }} -- {{ scope.row.weekEndDate }}</span>
            </template>
          </el-table-column>
        </el-table>

        <h3 style="margin-top: 30px">月活</h3>
        <el-date-picker
          v-model="mAuDate"
          type="month"
          size="mini"
          @change="mAuChange"
          format="yyyy 年 - MM 月"
          value-format="yyyy-MM"
          placeholder="选择月"
        >
        </el-date-picker>
        <el-table
          :data="mAu"
          style="margin-top: 20px"
          v-loading="mLoading"
          element-loading-background="rgba(0, 0, 0, 0.5)"
        >
          <el-table-column prop="total" label="月活跃量" align="center"></el-table-column>
          <el-table-column label="时间" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.month }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </el-dialog>

    <el-dialog
      title="选择landingLink"
      :visible.sync="showLandingLink"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-row class="table_parent">
        <el-table :data="landingLinkList" style="margin-top: 20px">
          <el-table-column
            prop="movieName"
            label="影片名称"
            align="center"
          ></el-table-column>
          <el-table-column label="影片ID" prop="movieId" align="center"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="success"
                @click="selectedLink(scope.row.movieId)"
                >选择</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </el-dialog>
  </el-row>
</template>

<script>
import { axiosGet, axiosPost } from "@/assets/ajaxFn.js";
import { formateDate } from "@/assets/dateUtils.js";
export default {
  data() {
    return {
      landingLinkList: [],
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 50,
      checkIng: false,
      updatIng: false,
      title: "新增App",
      total: 0,
      dialogFormVisible: false,
      form: {
        urlSwitchTime: "",
        name: "",
        cId: "",
        appName: "",
        enabled: 0,
        customerId: "",
        webviewUrl: [
          {
            value: "",
            showAdd: true,
            showMin: false,
          },
        ],
        packageName: "",
        webviewApiEnabled: 0,
        adManagerAppId: "",
        landingLink: "",
      },
      options: [], //存客户列表的Array
      keyword: "",
      rules: {
        customerId: [{ required: true, message: "请输入客户名称", trigger: "blur" }],
        appName: [
          { required: true, message: "请输入App名称", trigger: "blur" },
          { min: 3, max: 25, message: "长度在 3 到 25 个字符", trigger: "blur" },
        ],
        packageName: [{ required: true, message: "请输入packageName", trigger: "blur" }],
        urlSwitchTime: [{ required: true, message: "切换时间不能为空", trigger: "blur" }],
      },
      permissions: JSON.parse(sessionStorage.getItem("permission")),
      showAu: false,
      auTitle: "",
      auPackageName: "",
      auDate: "",
      dAu: [],
      wAu: [],
      mAu: [],
      mAuDate: "",
      dLoading: false,
      wLoading: false,
      mLoading: false,
      showLandingLink: false,
    };
  },
  methods: {
    selectedLink(id) {
      this.form.landingLink = id;
      this.showLandingLink = false;
    },
    showLinkModal() {
      this.showLandingLink = true;
      this.getLandingLinkList({ currentPage: 1, pageSize: 20 });
    },
    async getLandingLinkList(params) {
      const res = await axiosGet("/api/app_web/landing/list", params);
      if (res.code == 0) {
        this.landingLinkList = res.data.records;
      }
    },
    change(event) {
      this.$forceUpdate();
    },
    checkAu(row) {
      // console.log(row);
      this.auDate = formateDate(new Date());
      this.auTitle = row.appName + " 活跃度统计";
      this.auPackageName = row.packageName;
      this.getAuList(this.auDate);
    },
    async dAuChange(val) {
      this.dLoading = true;
      await axiosGet("/api/event/app_dau", {
        currentPage: 1,
        pageSize: 10,
        date: val,
        packageName: this.auPackageName,
      }).then((res) => {
        if (res.code == 0) {
          this.dLoading = false;
          this.dAu = res.data.records;
        }
      });
    },
    async wAuChange(val) {
      this.wLoading = true;
      await axiosGet("/api/event/app_wau", {
        currentPage: 1,
        pageSize: 10,
        date: val,
        packageName: this.auPackageName,
      }).then((res) => {
        if (res.code == 0) {
          this.wLoading = false;
          this.wAu = res.data.records;
          // this.showAu=true;
        }
      });
    },
    async mAuChange(val) {
      this.mLoading = true;
      await axiosGet("/api/event/app_mau", {
        currentPage: 1,
        pageSize: 10,
        date: val,
        packageName: this.auPackageName,
      }).then((res) => {
        if (res.code == 0) {
          this.mLoading = false;
          this.mAu = res.data.records;
        }
      });
    },
    async getAuList(auDate) {
      await axiosGet("/api/event/app_dau", {
        currentPage: 1,
        pageSize: 10,
        date: auDate,
        packageName: this.auPackageName,
      }).then((res) => {
        if (res.code == 0) {
          this.dAu = res.data.records;
        }
      });
      await axiosGet("/api/event/app_wau", {
        currentPage: 1,
        pageSize: 10,
        date: auDate,
        packageName: this.auPackageName,
      }).then((res) => {
        if (res.code == 0) {
          this.wAu = res.data.records;
          // this.showAu=true;
        }
      });
      await axiosGet("/api/event/app_mau", {
        currentPage: 1,
        pageSize: 10,
        date: this.mAuDate,
        packageName: this.auPackageName,
      }).then((res) => {
        if (res.code == 0) {
          this.mAu = res.data.records;
          this.showAu = true;
        }
      });
    },
    offCheck() {
      this.checkIng = false;
      this.dialogFormVisible = false;
      this.resetForm("ruleForm");
    },
    searchList() {
      this.pageSize = 50;
      this.currentPage = 1;
      this.getAppList({ currentPage: 1, pageSize: 20, keyword: this.keyword });
    },
    async getCustomList(params) {
      await axiosGet(
        "/api/customer/list?currentPage=" +
          params.currentPage +
          "&pageSize=" +
          params.pageSize +
          "&keyword=" +
          params.keyword
      ).then((res) => {
        if (res.code == 0) {
          this.options = res.data.records;
        }
      });
    },
    async check(packageName) {
      this.checkIng = true;
      this.title = "查看App信息";
      this.getAppDetail(packageName);
    },
    async update(packageName) {
      this.updatIng = true;
      this.title = "更新App信息";
      this.getAppDetail(packageName);
    },
    async offUpdating() {
      this.submitForm("ruleForm");
    },
    async getAppDetail(packageName) {
      this.loading = true;
      let res = await axiosGet("/api/app_web/detail", { packageName: packageName });
      if (res.code == 0) {
        this.form = res.data;
        this.form.webviewApiEnabled = res.data.webviewApiEnabled == 1 ? true : false;
        this.form.enabled = res.data.enabled == 1 ? true : false;
        this.form.adManagerAppId = res.data.adManagerAppId ? res.data.adManagerAppId : "";
        this.form.urlSwitchTime = res.data.urlSwitchTime / 1000;
        this.form.name = res.data.customerName;
        // this.form.landingLink=res.data.landingLink||"";
        let webArr = [];
        if (res.data.webUrl) {
          webArr = res.data.webUrl.split(",");
        }
        let newArr = [];
        if (webArr.length === 0) {
          newArr.push({
            value: "",
            showAdd: true,
            showMin: false,
          });
        } else if (webArr.length === 1) {
          newArr.push({
            value: webArr[0],
            showAdd: true,
            showMin: false,
          });
        } else {
          for (var i = 0; i < webArr.length; i++) {
            var currentItem = {
              value: webArr[i],
              showAdd: false,
              showMin: true,
            };
            if (i === 0) {
              currentItem.showAdd = false;
              currentItem.showMin = false;
            } else if (i === webArr.length - 1) {
              currentItem.showAdd = true;
              currentItem.showMin = true;
            }
            newArr.push(currentItem);
          }
        }
        this.form.webviewUrl = newArr;
        this.dialogFormVisible = true;
        // this.form.webUrl=res.data.webUrl.split('')
      }
    },
    async getAppList(params) {
      this.loading = true;
      const res = await axiosGet("/api/app_web/list", {
        currentPage: params.currentPage || "",
        pageSize: params.pageSize || "",
        keyword: params.keyword || "",
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data.records;
        this.total = res.data.total;
        this.loading = false;
        // console.log(this.tableData)
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getCustomList({ currentPage: 1, pageSize: 20, keyword: this.keyword });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getCustomList({ currentPage: 1, pageSize: 20, keyword: this.keyword });
    },
    searchCustom(keyword) {
      if (keyword != "") {
        this.getCustomList({ currentPage: 1, pageSize: 20, keyword: keyword });
      }
    },
    selectChange(val) {
      console.log(val);
    },
    async createApp() {
      this.dialogFormVisible = true;
      this.title = "新增APP";
      this.getCustomList({ currentPage: 1, pageSize: 20 });
    },
    addItem(arr, item) {
      //新增白名单ip
      this.$forceUpdate(); //强制更新视图
      if (arr.length > 8) {
        this.$message({ message: "最多可以添加9个", type: "error" });
        return false;
      }
      arr.push({
        value: "",
        showAdd: true,
        showMin: true,
      });
      arr[0].showAdd = false;
      arr[0].showMin = false;
      let index = arr.indexOf(item);
      if (index != 0) {
        arr[index].showAdd = false;
        arr[index].showMin = true;
      }
    },
    removeItem(arr, item) {
      this.$forceUpdate(); //
      let index = arr.indexOf(item);
      if (index != 0) {
        arr.splice(index, 1);
        arr[arr.length - 1].showAdd = true;
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let webUrl = [];
          for (var w = 0; w < this.form.webviewUrl.length; w++) {
            webUrl.push(this.form.webviewUrl[w].value);
          }
          let requestCreate = {
            adManagerAppId: this.form.adManagerAppId,
            appName: this.form.appName,
            customerId: this.form.customerId,
            enabled: this.form.enabled ? 1 : 0,
            ext: "备用",
            packageName: this.form.packageName,
            urlSwitchTime: this.form.urlSwitchTime * 1000,
            webUrl: webUrl.join(","),
            webviewApiEnabled: this.form.webviewApiEnabled ? 1 : 0,
            landingLink: this.form.landingLink || "",
          };
          let url = "",
            string = "";
          if (this.updatIng) {
            string = "更新";
            url = "/api/app_web/update";
          } else {
            url = "/api/app_web/add";
            string = "新建";
          }
          if (this.form.webviewApiEnabled) {
            if (!this.form.adManagerAppId) {
              this.$message({
                type: "error",
                message: "开启webViewApi必须搭配adManagerAppId",
              });
              return false;
            }
          }
          this.loading = true;
          axiosPost(url, requestCreate, "JSON").then((res) => {
            if (res.code == 0) {
              this.loading = false;
              this.dialogFormVisible = false;
              this.resetForm("ruleForm"); //重置表单
              this.$message({ message: `App${string}成功`, type: "success" });
              this.getAppList({ currentPage: this.currentPage, pageSize: this.pageSize });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
      this.checkIng = false;
      this.updatIng = false;
      this.loading = false;
      this.form = {
        urlSwitchTime: "",
        name: "",
        cId: "",
        appName: "",
        enabled: 0,
        customerId: "",
        webviewUrl: [
          {
            value: "",
            showAdd: true,
            showMin: false,
          },
        ],
        packageName: "",
        webviewApiEnabled: 0,
        adManagerAppId: "",
        landingLink: "",
      };
    },
  },
  mounted() {
    this.getAppList({ currentPage: this.currentPage, pageSize: this.pageSize });
    this.mAuDate =
      new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1 > 9
        ? new Date().getMonth() + 1
        : "0" + (new Date().getMonth() + 1));
    // console.log(this.mAuDate)
  },
};
</script>
<style>
.el-form-item__content {
  display: flex;
}

#login .el-form-item__content {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/view/AppManager/appManager.vue